import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { normalizeIds } from '../utils/normalize';
import { getSelectedContainers } from '../../data/selectedcontainers';

export const useVoyageContainers = (voyage: any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!voyage?.containers) return;

    const voyageContainerIds = normalizeIds(voyage.containers);

    dispatch(getSelectedContainers(voyageContainerIds));
  }, [voyage, dispatch]);
};